module.exports = __webpack_public_path__ + "img/icon_touxiang_four@3x.00605912.png";